<template>
  <div>
    <b-form-group
      v-if="!isNaN(egress_profile.id) && show_selected_career"
      :label="`${$getVisibleNames('mesh.career', false, 'Programa')}`"
      label-for="select-career"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <div class="d-flex">
        <div class="d-block w-100">
          <b-form-select
            id="select-career"
            v-model="$v.egress_profile.career.$model"
            :state="validateState('career')"
            aria-describedby="select-career-feedback"
            size="sm"
            :options="careers"
            @change="() => (egress_profile.campuses = [])"
            value-field="id"
            text-field="name"
          ></b-form-select>
          <b-form-invalid-feedback id="select-career-feedback">{{
            $t("reusable.common.mustSelect", {
              entity: $getVisibleNames("mesh.career", false, "Programa"),
            })
          }}</b-form-invalid-feedback>
        </div>
        <button
          class="btn-add"
          v-b-tooltip.v-secondary.noninteractive="
            `${$t('reusable.common.create')} ${$getVisibleNames(
              'mesh.career',
              false,
              'Programa'
            )}`
          "
          @click="$bvModal.show(`new-career-modal-${egress_profile.id}`)"
        >
          <b-icon font-scale="1" icon="plus-square"></b-icon>
        </button>
      </div>
    </b-form-group>
    <b-form-group
      :label="`${$getVisibleNames(
        'manual.mesh.titulo_profesional',
        false,
        'Título Profesional'
      )}`"
      label-for="input-title"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0 mt-2"
    >
      <b-form-input
        id="input-title"
        v-model="$v.egress_profile.professional_title.$model"
        :state="validateState('professional_title')"
        aria-describedby="input-title-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-title-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="
        !(
          (institution && institution.internal_use_id == 'duoc.cl') ||
          !institution.show_academic_degree
        )
      "
      :label="`${$getVisibleNames(
        'manual.grado_academico',
        false,
        'Grado Académico'
      )}`"
      label-for="input-degree"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-degree"
        v-model="$v.egress_profile.academic_degree.$model"
        :state="validateState('academic_degree')"
        aria-describedby="input-degree-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-degree-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="`${$getVisibleNames(
        'manual.egress_profile_code',
        false,
        'Código de Perfil de Egreso'
      )}`"
      label-for="input-code"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-code"
        v-model="$v.egress_profile.code.$model"
        :state="validateState('code')"
        @update="
          (value) => {
            egress_profile.code = value.toUpperCase();
          }
        "
        aria-describedby="input-code-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-code-feedback">
        <div v-if="egress_profile.code.length > 256">
          {{
            $t("reusable.common.maxLength", {
              max: 256,
            })
          }}
        </div>
        <div
          v-else-if="
            this.egress_profile_code_list.find(
              (x) =>
                this.$equals(x.code, this.egress_profile.code) &&
                x.id != this.egress_profile.id
            )
          "
        >
          {{ $t("curricularProducts.egressProfile.codeAlreadyUsed") }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.internal_use_id == 'duoc.cl'"
      :label="`${$getVisibleNames(
        'manual.egress_profile_code',
        false,
        'Código de Perfil de Egreso'
      )} ${$t('curricularProducts.egressProfile.previous')}`"
      label-for="input-code"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-code"
        v-model="$v.egress_profile.previous_curriculum_number.$model"
        :state="validateState('previous_curriculum_number')"
        @update="
          (value) => {
            egress_profile.previous_curriculum_number = value.toUpperCase();
          }
        "
        aria-describedby="input-code-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-code-feedback">
        <div v-if="egress_profile.previous_curriculum_number.length > 256">
          {{
            $t("reusable.common.maxLength", {
              max: 256,
            })
          }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.internal_use_id == 'duoc.cl'"
      :label="$t('curricularProducts.egressProfile.intermediateOutputCode')"
      label-for="input-code"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-code"
        v-model="$v.egress_profile.intermediate_output_code.$model"
        :state="validateState('intermediate_output_code')"
        @update="
          (value) => {
            egress_profile.intermediate_output_code = value.toUpperCase();
          }
        "
        aria-describedby="input-code-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-code-feedback">
        <div v-if="egress_profile.intermediate_output_code.length > 256">
          {{
            $t("reusable.common.maxLength", {
              max: 256,
            })
          }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.internal_use_id == 'duoc.cl'"
      :label="$t('curricularProducts.egressProfile.intermediateOutputName')"
      label-for="input-code"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-code"
        v-model="$v.egress_profile.intermediate_output_name.$model"
        :state="validateState('code')"
        @update="
          (value) => {
            egress_profile.intermediate_output_name = value.toUpperCase();
          }
        "
        aria-describedby="input-code-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-code-feedback">
        <div v-if="egress_profile.intermediate_output_name.length > 256">
          {{
            $t("reusable.common.maxLength", {
              max: 256,
            })
          }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.internal_use_id == 'duoc.cl'"
      :label="$t('curricularProducts.egressProfile.continuityCode')"
      label-for="input-code"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-code"
        v-model="$v.egress_profile.continuity_code.$model"
        :state="validateState('continuity_code')"
        aria-describedby="input-code-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-code-feedback">
        <div v-if="egress_profile.continuity_code.length > 256">
          {{
            $t("reusable.common.maxLength", {
              max: 256,
            })
          }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.internal_use_id == 'duoc.cl'"
      :label="$t('curricularProducts.egressProfile.continuityName')"
      label-for="input-code"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-code"
        v-model="$v.egress_profile.continuity_name.$model"
        :state="validateState('continuity_name')"
        aria-describedby="input-code-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-code-feedback">
        <div v-if="egress_profile.continuity_name.length > 256">
          {{
            $t("reusable.common.maxLength", {
              max: 256,
            })
          }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label-cols="0"
      label-cols-sm="3"
      :label="$getVisibleNames('mesh.periodtype', false, 'Régimen')"
      label-for="input-regime"
      class="label mt-1 mb-2 mx-0"
    >
      <b-form-select
        id="input-regime"
        :options="regimesList"
        v-model="$v.egress_profile.regime.$model"
        value-field="id"
        text-field="name"
        :state="validateState('regime')"
        type="number"
        aria-describedby="input-regime-feedback"
        size="sm"
      ></b-form-select>
      <b-form-invalid-feedback id="input-regime-feedback">{{
        $t("reusable.common.mustSelect", {
          entity: $getVisibleNames("mesh.periodtype", false, "Régimen"),
        })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('curricularProducts.egressProfile.duration')"
      label-for="input-semester"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-semester"
        type="number"
        min="1"
        max="40"
        v-model="$v.egress_profile.semester_amount.$model"
        :state="validateState('semester_amount')"
        aria-describedby="input-semester-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-semester-feedback">
        <div v-if="!$v.egress_profile.semester_amount.required">
          {{ $t("reusable.common.required") }}
        </div>
        <div v-else-if="!$v.egress_profile.semester_amount.between">
          {{ $t("curricularProducts.egressProfile.durationRange") }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.internal_use_id == 'duoc.cl'"
      :label="$t('curricularProducts.egressProfile.intermediateOutputSemester')"
      label-for="input-intermediate_output_semester"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-input
        id="input-intermediate_output_semester"
        type="number"
        min="1"
        max="20"
        v-model="$v.egress_profile.intermediate_output_semester.$model"
        @update="
          (value) => {
            if (value == '') egress_profile.intermediate_output_semester = null;
          }
        "
        :state="validateState('intermediate_output_semester')"
        aria-describedby="iintermediate_output_semester-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="iintermediate_output_semester-feedback">
        <div
          v-if="
            egress_profile.intermediate_output_semester > 0 &&
            egress_profile.semester_amount > 0 &&
            parseFloat(egress_profile.intermediate_output_semester) >
              parseFloat(egress_profile.semester_amount)
          "
        >
          {{ $t("curricularProducts.egressProfile.cannotExceedDuration") }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('curricularProducts.egressProfile.modality')"
      label-for="select-type"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-select
        id="select-type"
        v-model="$v.egress_profile.modality.$model"
        :state="validateState('modality')"
        aria-describedby="select-type-feedback"
        size="sm"
        :options="modalities_egress_profiles"
        value-field="id"
        text-field="name"
        ><template #first>
          <b-form-select-option :value="null"
            >{{ $t("reusable.common.notApplicable") }}
          </b-form-select-option></template
        ></b-form-select
      >
      <b-form-invalid-feedback id="select-type-feedback">{{
        $t("curricularProducts.egressProfile.mustSelectProfileType")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.internal_use_id == 'duoc.cl'"
      :label="$t('curricularProducts.egressProfile.admissionType')"
      label-for="select-type"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-select
        id="select-type"
        v-model="$v.egress_profile.admission_type.$model"
        :state="validateState('admission_type')"
        aria-describedby="select-type-feedback"
        size="sm"
        :options="admission_types"
        value-field="id"
        text-field="value"
        ><template #first>
          <b-form-select-option :value="null"
            >{{ $t("reusable.common.notApplicable") }}
          </b-form-select-option></template
        ></b-form-select
      >
      <b-form-invalid-feedback id="select-type-feedback">{{
        $t("curricularProducts.egressProfile.mustSelectAdmissionType")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="
        $getVisibleNames('mesh.facultyarea', false, 'Área de Facultad') + ':'
      "
      label-for="select-faculty_area"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-select
        id="select-faculty_area"
        v-model="$v.egress_profile.faculty_area.$model"
        :state="validateState('faculty_area')"
        aria-describedby="select-faculty_area-feedback"
        size="sm"
        :options="faculty_areas"
        value-field="id"
        text-field="name"
        ><template #first>
          <b-form-select-option :value="null"
            >{{ $t("reusable.common.notApplicable") }}
          </b-form-select-option></template
        ></b-form-select
      >
      <b-form-invalid-feedback id="select-type-feedback">{{
        $t("reusable.common.mustSelect", {
          entity: $getVisibleNames(
            "mesh.facultyarea",
            false,
            "Área de Facultad"
          ),
        })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="institution && institution.show_ep_full_init_date"
      :label="$t('curricularProducts.egressProfile.initDate')"
      label-for="input-start-date"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <b-form-datepicker
        id="input-start-date"
        v-model="$v.egress_profile.init_date.$model"
        :state="validateState('init_date')"
        :placeholder="$t('curricularProducts.egressProfile.defineInitDate')"
        aria-describedby="input-start-date-feedback"
        size="sm"
      ></b-form-datepicker>
      <b-form-invalid-feedback id="input-start-date-feedback">{{
        $t("curricularProducts.egressProfile.mustEnterValidInitDate")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-else
      :label="$t('curricularProducts.egressProfile.vigencyYear')"
      label-for="input-start-date"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <b-form-input
        id="init_date-input"
        name="init_date-input"
        v-model="$v.egress_profile.init_date.$model"
        type="number"
        :state="validateState('init_date')"
        aria-describedby="input-init_date-live-feedback"
      ></b-form-input>
      <b-form-invalid-feedback id="input-init_date-live-feedback">{{
        $t("curricularProducts.egressProfile.enterValidYear")
      }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- <b-form-group
      :label="`${$getVisibleNames(
        'manual.ambito_de_desempeño_profesional',
        false,
        'Ámbito de Desempeño Profesional'
      )}`"
      label-for="input-scope"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-textarea
        id="input-scope"
        v-model="$v.egress_profile.scope.$model"
        :state="validateState('scope')"
        aria-describedby="input-scope-feedback"
        size="sm"
      ></b-form-textarea>
      <b-form-invalid-feedback id="input-scope-feedback"
        >Este campo es obligatorio.</b-form-invalid-feedback
      >
    </b-form-group> -->
    <!-- <b-form-group
      label="Descripción"
      label-for="input-description"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-textarea
        id="input-description"
        v-model="$v.egress_profile.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-feedback"
        size="sm"
      ></b-form-textarea>
      <b-form-invalid-feedback id="input-description-feedback"
        >Este campo es obligatorio.</b-form-invalid-feedback
      >
    </b-form-group> -->
    <!-- <b-form-group
      label="Comentarios"
      label-for="input-comments"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
    >
      <b-form-textarea
        id="input-comments"
        v-model="egress_profile.comments"
        :state="true"
        aria-describedby="input-comments-feedback"
        size="sm"
        class="textarea"
      ></b-form-textarea>
      <b-form-invalid-feedback id="input-comments-feedback"
        >Este campo es obligatorio.</b-form-invalid-feedback
      >
    </b-form-group> -->
    <b-form-group
      :label="$getVisibleNames('mesh.campus', true, 'Sedes')"
      label-for="input-campus"
      label-cols="0"
      label-cols-sm="3"
      class="p-0 m-0"
      :description="
        $t('curricularProducts.egressProfile.campusesDescription', {
          campuses: $getVisibleNames('mesh.campus', true, 'Sedes'),
          faculty: $getVisibleNames('mesh.faculty', false, 'Facultad'),
        })
      "
    >
      <!-- <b-form-select
        id="input-campus"
        v-model="egress_profile.campuses"
        :options="filteredCampuses"
        value-field="id"
        text-field="name"
        :state="validateState('campuses')"
        aria-describedby="input-campuses-feedback"
        size="sm"
        multiple
        :select-size="
          filteredCampuses.length > 5
            ? 5
            : filteredCampuses.length < 1
            ? 1
            : filteredCampuses.length
        "
      ></b-form-select> -->
      <v-select
        id="input-modality"
        class="v-select-class"
        :options="filteredCampuses"
        v-model="$v.egress_profile.campuses.$model"
        :reduce="(filteredCampuses) => filteredCampuses.id"
        :state="validateState('campuses')"
        :placeholder="
          filteredCampuses.length > 0
            ? $t('curricularProducts.egressProfile.selectOneOrMultiple', {
                entity: $getVisibleNames(
                  'mesh.campus',
                  true,
                  'Sedes'
                ).toLowerCase(),
              })
            : $t('reusable.common.noCreated', {
                entity: $getVisibleNames(
                  'mesh.campus',
                  true,
                  'Sedes'
                ).toLowerCase(),
              })
        "
        multiple
        :selectable="(option) => !egress_profile.campuses.includes(option.id)"
        :dropdown-should-open="dropdownShouldOpen"
        label="name"
        track-by="id"
        size="sm"
      >
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            {{ $t("curricularProducts.egressProfile.noResults") }}
            <em>{{ search }}</em
            >.
          </template>
        </template>
        <template v-slot:option="option">
          {{ option.name }}
        </template>
      </v-select>
      <b-form-invalid-feedback id="input-campuses-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      v-if="!isNaN(egress_profile.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="egress_profile"></ModificationDate>
    </b-form-group>

    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(egress_profile.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteEgressProfile"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div class="col" style="text-align: right">
        <b-button
          v-if="isNaN(egress_profile.id) && showAiQuickCreation"
          class="mr-1 btn-ai-quick"
          size="sm"
          @click="saveEgressProfileWithAi"
        >
          <img src="@/assets/icon-ai.svg" alt="" class="icon-btn-ai mr-1" />
          {{ $t("reusable.aiEgressProfileBuilderModal.openButton") }}
        </b-button>
        <b-button class="mr-1" size="sm" @click="saveEgressProfile">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
    <AiEgressProfileBuilderModal
      v-if="ai_created_profile"
      ref="ai_builder_modal"
      :egress_profile_id="ai_created_profile.id"
      @closed="slotAiBuilderClosed"
    ></AiEgressProfileBuilderModal>
    <b-modal
      :id="`new-career-modal-${egress_profile.id}`"
      :title="`${$t('reusable.common.create')} ${$getVisibleNames(
        'mesh.career',
        false,
        'Programa'
      )}`"
      size="md"
      hide-footer
    >
      <CareerForm @created="slotCreatedCareer" :show_title="false"></CareerForm>
    </b-modal>
    <b-modal
      :id="`modal-change-ep-matter-coruse-wrapper-${egress_profile.semester_amount}`"
      :title="`${$t(
        'curricularProducts.egressProfile.durationOf'
      )} ${$getVisibleNames(
        'mesh.egressprofile',
        false,
        'Perfil de Egreso'
      )}: ${egress_profile.semester_amount}`"
      size="xl"
      @hide="returnSemesterAmount"
      hide-footer
    >
      <template
        v-if="
          courses_wrapper.filter(
            (x) =>
              x.init_level > egress_profile.semester_amount &&
              x.egress_profile == egress_profile.id
          ).length > 0
        "
      >
        <CoursesWrapperView
          :semester_amount="
            egress_profile.semester_amount == '' ||
            egress_profile.semester_amount == null
              ? 0
              : egress_profile.semester_amount
          "
          :egress_profile_id="egress_profile.id"
          :allows_crud="true"
          :matrix2_view="false"
          @list_courses_wrapper="updateCoursesWrapperView"
        ></CoursesWrapperView>
      </template>
      <template
        v-if="
          egressProfileMatters.filter(
            (x) =>
              x.plan_level > egress_profile.semester_amount &&
              x.egress_profile == egress_profile.id
          ).length > 0
        "
      >
        <RemoveEPMattersComponent
          :semester_amount="
            egress_profile.semester_amount == '' ||
            egress_profile.semester_amount == null
              ? 0
              : egress_profile.semester_amount
          "
          :egress_profile_id="egress_profile.id"
          :allows_crud="true"
          :matrix2_view="false"
          @list_matters="updateRemoveEPMattersComponent"
        >
        </RemoveEPMattersComponent>
      </template>
      <div class="d-flex">
        <div style="margin-left: 0; margin-right: auto">
          <b-button
            size="sm"
            class="ml-3"
            v-b-tooltip.v-danger.noninteractive="
              $t('curricularProducts.egressProfile.whenCanceling', {
                entity: $getVisibleNames(
                  'mesh.egressprofile',
                  false,
                  'Perfil de Egreso'
                ),
              })
            "
            @click="
              $bvModal.hide(
                `modal-change-ep-matter-coruse-wrapper-${egress_profile.semester_amount}`
              )
            "
          >
            {{ $t("reusable.common.cancel") }}
          </b-button>
        </div>
        <div style="margin-left: auto; margin-right: 0">
          <template
            v-if="
              list_courses_wrapper.filter(
                (x) =>
                  (x.init_level > egress_profile.semester_amount ||
                    x.end_level < x.init_level ||
                    x.end_level > egress_profile.semester_amount ||
                    x.init_level <= 0 ||
                    x.end_semester <= 0 ||
                    x.init_level == '' ||
                    x.end_level == '') &&
                  x.egress_profile == egress_profile.id
              ).length == 0 &&
              list_matters.filter(
                (x) =>
                  (x.plan_level > egress_profile.semester_amount ||
                    x.plan_level == '' ||
                    x.plan_level <= 0) &&
                  x.egress_profile == egress_profile.id
              ).length == 0
            "
          >
            <b-button
              class="mr-1"
              size="sm"
              @click="removeMattersAndCoursesWrapper()"
              >{{
                $t("curricularProducts.egressProfile.applyChanges")
              }}</b-button
            >
          </template>
          <template v-else>
            <b-button class="mr-1" size="sm" disabled>{{
              $t("curricularProducts.egressProfile.applyChanges")
            }}</b-button>
          </template>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// Import directo (no lazy): se abre vía $refs inmediatamente después de crearlo.
import AiEgressProfileBuilderModal from "@/components/reusable/AiEgressProfileBuilderModal";

export default {
  name: "EgressProfileForm",
  mixins: [validationMixin],
  components: {
    vSelect,
    // StyleTextArea: () => import("@/components/reusable/StyledTextArea"),
    CareerForm: () =>
      import("@/components/mesh/CurricularResources/Career/CareerForm"),
    CoursesWrapperView: () =>
      import("@/components/mesh/Matrix2/CoursesWrapper/CoursesWrapperView"),
    RemoveEPMattersComponent: () =>
      import("@/components/mesh/Matrix2/RemoveEPMattersComponent"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    AiEgressProfileBuilderModal,
  },
  props: {
    default_max_semester_amount: {
      type: [Number, null],
      default: 0,
    },
    EgressProfile: {
      type: Object,
    },
    career_id: {
      type: Number,
      required: true,
    },
    show_selected_career: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      egress_profile: {
        id: this.EgressProfile ? this.EgressProfile.id : generateUniqueId(),
        // description: this.EgressProfile ? this.EgressProfile.description : "",
        // scope: this.EgressProfile ? this.EgressProfile.scope : "",
        academic_degree: this.EgressProfile
          ? this.EgressProfile.academic_degree
          : "",
        professional_title: this.EgressProfile
          ? this.EgressProfile.professional_title
          : "",
        code: this.EgressProfile ? this.EgressProfile.code : "",
        previous_curriculum_number: this.EgressProfile
          ? this.EgressProfile.previous_curriculum_number
          : "",
        intermediate_output_code: this.EgressProfile
          ? this.EgressProfile.intermediate_output_code
          : "",
        intermediate_output_name: this.EgressProfile
          ? this.EgressProfile.intermediate_output_name
          : "",
        continuity_code: this.EgressProfile
          ? this.EgressProfile.continuity_code
          : "",
        continuity_name: this.EgressProfile
          ? this.EgressProfile.continuity_name
          : "",
        intermediate_output_semester: this.EgressProfile
          ? this.EgressProfile.intermediate_output_semester
          : null,
        init_date: this.EgressProfile ? this.EgressProfile.init_date : null,
        faculty_area: this.EgressProfile
          ? this.EgressProfile.faculty_area
          : null,
        modality: this.EgressProfile ? this.EgressProfile.modality : null,
        admission_type: this.EgressProfile
          ? this.EgressProfile.admission_type
          : null,
        regime: this.EgressProfile ? this.EgressProfile.regime : null,
        // egress_profile_type: this.EgressProfile
        //   ? this.EgressProfile.egress_profile_type
        //   : null,
        career: this.EgressProfile ? this.EgressProfile.career : this.career_id,
        semester_amount: this.EgressProfile
          ? this.EgressProfile.semester_amount
          : this.default_max_semester_amount,
        campuses: this.EgressProfile ? this.EgressProfile.campuses : [],
        // comments: this.EgressProfile ? this.EgressProfile.comments : "",
        updated_by: this.EgressProfile ? this.EgressProfile.updated_by : null,
        update_date: this.EgressProfile ? this.EgressProfile.update_date : null,
      },
      egress_profile_code_list: [],
      egress_profile_previous_curriculum_number_list: [],
      egress_profile_intermediate_output_code_list: [],
      egress_profile_intermediate_output_name_list: [],
      faculty_areas: [],
      list_matters: [],
      remove_matters: [],
      list_courses_wrapper: [],
      remove_courses_wrapper: [],
      ai_created_profile: null,
      // egress_profile_types: [],
    };
  },
  validations: {
    egress_profile: {
      code: {
        maxLength: maxLength(256),
        isUnique() {
          if (this.egress_profile.code == "") return true;
          else if (
            this.egress_profile_code_list.find(
              (x) =>
                this.$equals(x.code, this.egress_profile.code) &&
                x.id != this.egress_profile.id
            )
          )
            return false;
          else return true;
        },
      },
      previous_curriculum_number: {
        maxLength: maxLength(256),
        isUnique() {
          if (this.egress_profile.previous_curriculum_number == "") return true;
          else if (
            this.egress_profile_previous_curriculum_number_list.find(
              (x) =>
                this.$equals(
                  x.previous_curriculum_number,
                  this.egress_profile.previous_curriculum_number
                ) && x.id != this.egress_profile.id
            )
          )
            return false;
          else return true;
        },
      },
      intermediate_output_code: {
        maxLength: maxLength(256),
        isUnique() {
          if (this.egress_profile.intermediate_output_code == "") return true;
          else if (
            this.egress_profile_intermediate_output_code_list.find(
              (x) =>
                this.$equals(
                  x.intermediate_output_code,
                  this.egress_profile.intermediate_output_code
                ) && x.id != this.egress_profile.id
            )
          )
            return false;
          else return true;
        },
      },
      intermediate_output_name: {
        maxLength: maxLength(256),
        isUnique() {
          if (this.egress_profile.intermediate_output_name == "") return true;
          else if (
            this.egress_profile_intermediate_output_name_list.find(
              (x) =>
                this.$equals(
                  x.intermediate_output_name,
                  this.egress_profile.intermediate_output_name
                ) && x.id != this.egress_profile.id
            )
          )
            return false;
          else return true;
        },
      },
      continuity_code: {},
      continuity_name: {},
      intermediate_output_semester: {
        isValid() {
          if (
            (this.egress_profile.intermediate_output_semester > 0 &&
              this.egress_profile.intermediate_output_semester <
                this.egress_profile.semester_amount) ||
            this.egress_profile.intermediate_output_semester == null ||
            this.egress_profile.intermediate_output_semester == ""
          )
            return true;
          return false;
        },
      },
      regime: { required },
      modality: {},
      admission_type: {},
      init_date: {
        isValid() {
          if (this.institution && !this.institution.show_ep_full_init_date) {
            if (
              (this.egress_profile.init_date > 1900 &&
                this.egress_profile.init_date <
                  parseInt(new Date().getFullYear()) + 30) ||
              this.egress_profile.init_date == "" ||
              this.egress_profile.init_date == null
            )
              return true;
            else return false;
          } else {
            return true;
          }
        },
      },
      academic_degree: {},
      professional_title: { required },
      faculty_area: {},
      // egress_profile_type: { required },
      career: { required },
      semester_amount: {
        required,
        between(value) {
          return value >= 1 && value <= 40;
        },
      },
      campuses: {},
    },
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      user: "getUser",
      careers: names.CAREERS,
      faculties: names.FACULTIES,
      campuses: names.CAMPUSES,
      regimes: names.REGIMES,
      modalities_egress_profiles: names.MODALITIES_EGRESS_PROFILE,
      egress_profiles: names.EGRESS_PROFILES,
      egressProfileMatters: names.EGRESS_PROFILES_MATTERS,
      courses_wrapper: names.COURSES_WRAPPER,
      admission_types: names.ADMISSION_TYPES,
    }),
    regimesList() {
      //Bimestral(2) - Trimestral(3) - Semestral(6)
      return this.regimes
        .filter((x) => [2, 3, 6].includes(x.months_amount))
        .sort((a, b) => b.months_amount - a.months_amount);
    },
    career() {
      return this.careers.find((x) => x.id == this.egress_profile.career);
    },
    faculty() {
      if (!this.career) return null;
      return this.faculties.find((x) => x.id == this.career.faculty);
    },
    showAiQuickCreation() {
      return (
        this.institution &&
        this.institution.kl_ai_quick_creation &&
        this.user &&
        (this.user.user_data == null ||
          (this.user.user_data && this.user.user_data.ai_component)) &&
        (this.user.is_superuser ||
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
          ].some((group) => this.user.group_names.includes(group)))
      );
    },
    filteredCampuses() {
      let list = [];
      if (!this.faculty) return list;
      this.faculty.campuses.forEach((campus_id) => {
        const instance = this.campuses.find((x) => x.id == campus_id);
        if (instance) list.push(instance);
      });
      return list;
    },
  },
  methods: {
    changeEPMatterAndCourseWrapper() {
      if (
        this.egressProfileMatters.filter(
          (x) =>
            x.plan_level > this.egress_profile.semester_amount &&
            x.egress_profile == this.egress_profile.id
        ).length > 0 ||
        this.courses_wrapper.filter(
          (x) =>
            x.init_level > this.egress_profile.semester_amount &&
            x.egress_profile == this.egress_profile.id
        ).length > 0
      ) {
        if (this.egress_profile.semester_amount >= 0)
          this.$bvModal.show(
            `modal-change-ep-matter-coruse-wrapper-${this.egress_profile.semester_amount}`
          );
      } else this.updateEgressProfile();
    },
    returnSemesterAmount() {
      if (
        this.egressProfileMatters.filter(
          (x) =>
            x.plan_level > this.egress_profile.semester_amount &&
            x.egress_profile == this.egress_profile.id
        ).length > 0 ||
        this.courses_wrapper.filter(
          (x) =>
            x.init_level > this.egress_profile.semester_amount &&
            x.egress_profile == this.egress_profile.id
        ).length > 0
      ) {
        this.egress_profile.semester_amount =
          this.egress_profiles.find((x) => x.id == this.egress_profile.id)
            .semester_amount || 1;
      }
    },
    removeMattersAndCoursesWrapper() {
      this.$swal({
        title: this.$t("reusable.common.sureToApplyChanges"),
        width: "auto",
        text: this.$t("reusable.common.deleteConfirmText"),
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          // this.saveMatterAndCoursesWrapper();
          this.$restful
            .Post(`/mesh/edit_or_delete_course_or_epm/`, {
              egress_profile_matters_to_change: this.list_matters.map((x) => ({
                id: x.id,
                plan_level: x.plan_level,
              })),
              course_wrappers_to_change: this.list_courses_wrapper.map((x) => ({
                id: x.id,
                init_level: x.init_level,
                end_level: x.end_level,
              })),
              egress_profile_matters_to_delete: this.remove_matters.map(
                (x) => x.id
              ),
              course_wrappers_to_delete: this.remove_courses_wrapper.map(
                (x) => x.id
              ),
            })
            .then(() => {
              this.list_matters.forEach((x) => {
                this.$store.commit(names.MUTATE_EGRESS_PROFILE_MATTER, x);
              });
              this.remove_matters.forEach((x) => {
                this.$store.commit(
                  names.MUTATE_DELETE_EGRESS_PROFILE_MATTER,
                  x.id
                );
              });
              this.list_courses_wrapper.forEach((x) => {
                this.$store.commit(names.MUTATE_COURSE_WRAPPER, x);
              });
              this.remove_courses_wrapper.forEach((x) => {
                this.$store.commit(names.MUTATE_DELETE_COURSE_WRAPPER, x.id);
              });
              this.updateEgressProfile();
              this.$bvModal.hide(
                `modal-change-ep-matter-coruse-wrapper-${this.egress_profile.semester_amount}`
              );
            });
        }
      });
    },
    // async saveMatterAndCoursesWrapper() {
    //   for await (let ep_matter of this.remove_matters) {
    //     await this.$store.dispatch(
    //       names.DELETE_EGRESS_PROFILE_MATTER,
    //       ep_matter.id
    //     );
    //   }
    //   for await (let course_wrapper of this.remove_courses_wrapper) {
    //     await this.$store.dispatch(
    //       names.DELETE_COURSE_WRAPPER,
    //       course_wrapper.id
    //     );
    //   }
    //   for await (let ep_matter of this.list_matters) {
    //     await this.$store.dispatch(names.PATCH_EGRESS_PROFILE_MATTER, {
    //       egress_profile_matter_id: ep_matter.id,
    //       item: { plan_level: ep_matter.plan_level },
    //     });
    //   }
    //   for await (let course_wrapper of this.list_courses_wrapper) {
    //     await this.$store.dispatch(names.PATCH_COURSE_WRAPPER, {
    //       course_wrapper_id: course_wrapper.id,
    //       item: {
    //         init_level: course_wrapper.init_level,
    //         end_level: course_wrapper.end_level,
    //       },
    //     });
    //   }
    //   this.updateEgressProfile();
    //   this.$bvModal.hide("modal-change-ep-matter-coruse-wrapper");
    // },
    updateRemoveEPMattersComponent(list_matters, remove_matters) {
      this.list_matters = list_matters;
      this.remove_matters = remove_matters;
    },
    updateCoursesWrapperView(list_courses_wrapper, remove_courses_wrapper) {
      this.list_courses_wrapper = list_courses_wrapper;
      this.remove_courses_wrapper = remove_courses_wrapper;
    },
    dropdownShouldOpen(VueSelect) {
      if (this.filteredCampuses.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    slotCreatedCareer(career) {
      this.egress_profile.career = career.id;
      this.egress_profile.campuses = [];
      this.$bvModal.hide(`new-career-modal-${this.egress_profile.id}`);
    },
    validateState(key) {
      const { $dirty, $error } = this.$v.egress_profile[key];
      return $dirty ? !$error : null;
    },
    // fetchEgressProfileTypes() {
    //   this.$restful.GetAll(`/mesh/egress-profile-type/`).then((response) => {
    //     this.egress_profile_types = response;
    //   });
    // },
    saveEgressProfile() {
      this.$v.egress_profile.$touch();
      if (this.$v.egress_profile.$anyError) {
        return;
      }
      if (this.egress_profile.intermediate_output_semester == "")
        this.egress_profile.intermediate_output_semester = null;
      if (!isNaN(this.egress_profile.id)) this.changeEPMatterAndCourseWrapper();
      else this.createEgressProfile();
    },
    saveEgressProfileWithAi() {
      this.$v.egress_profile.$touch();
      if (this.$v.egress_profile.$anyError) {
        return;
      }
      if (this.egress_profile.intermediate_output_semester == "")
        this.egress_profile.intermediate_output_semester = null;
      if (isNaN(this.egress_profile.id)) this.createEgressProfile(true);
    },
    slotAiBuilderClosed() {
      if (this.ai_created_profile) {
        this.$emit("created", this.ai_created_profile);
        this.ai_created_profile = null;
      }
    },
    createEgressProfile(open_ai_builder = false) {
      let payload = { ...this.egress_profile };
      if (this.institution && !this.institution.show_ep_full_init_date)
        if (
          this.egress_profile.init_date != "" &&
          this.egress_profile.init_date != null
        )
          payload.init_date = String(this.egress_profile.init_date) + "-01-01";
        else if (this.egress_profile.init_date == "") payload.init_date = null;
      this.$store
        .dispatch(names.POST_EGRESS_PROFILE, payload)
        .then((response) => {
          toast(
            this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ) +
              " " +
              this.$t("reusable.common.created")
          );
          if (open_ai_builder) {
            // El emit "created" se pospone hasta cerrar el modal de IA,
            // porque el padre puede desmontar el formulario al recibirlo.
            this.ai_created_profile = response;
            this.$nextTick(() => {
              if (this.$refs.ai_builder_modal)
                this.$refs.ai_builder_modal.open();
            });
          } else this.$emit("created", response);
        });
    },
    updateEgressProfile() {
      let payload = { ...this.egress_profile };
      if (this.institution && !this.institution.show_ep_full_init_date)
        if (
          this.egress_profile.init_date != "" &&
          this.egress_profile.init_date != null
        )
          payload.init_date = String(this.egress_profile.init_date) + "-01-01";
        else if (this.egress_profile.init_date == "") payload.init_date = null;
      this.$store
        .dispatch(names.UPDATE_EGRESS_PROFILE, payload)
        .then((response) => {
          this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
            egress_profile_id: response.id,
          });
          toast(
            this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ) +
              " " +
              this.$t("reusable.common.updated")
          );
          this.$emit("updated", response);
        });
    },
    deleteEgressProfile() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de Egreso"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_EGRESS_PROFILE, this.egress_profile.id)
            .then(() => {
              toast(
                this.$getVisibleNames(
                  "mesh.egressprofile",
                  false,
                  "Perfil de Egreso"
                ) +
                  " " +
                  this.$t("reusable.common.deleted")
              );
              this.$emit("deleted", this.egress_profile);
            });
        }
      });
    },
    fetchFacultyArea() {
      if (this.faculty)
        this.$restful
          .GetAll(`/mesh/faculty-area/?faculty=${this.faculty.id}`)
          .then((response) => {
            this.faculty_areas = response;
          });
    },
  },
  created() {
    this.$restful.Get(`/mesh/egress_profile_code_list/`).then((response) => {
      this.egress_profile_code_list = response;
    });
    if (!isNaN(this.egress_profile.id)) {
      this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
        egress_profile_id: this.egress_profile.id,
      });
      this.$store.dispatch(names.FETCH_MATTERS, {
        egress_profile_id: this.egress_profile.id,
      });
      this.$store.dispatch(names.FETCH_COURSES_WRAPPER, {
        egress_profile_id: this.egress_profile.id,
      });
    }
    this.$store.dispatch(names.FETCH_REGIMES);
    this.$store.dispatch(names.FETCH_CAMPUSES);
    this.$store.dispatch(names.FETCH_ADMISSION_TYPES);
    // this.fetchEgressProfileTypes();
  },
  mounted() {
    if (
      !isNaN(this.egress_profile.id) &&
      this.institution &&
      !this.institution.show_ep_full_init_date
    )
      if (this.egress_profile.init_date != null)
        this.egress_profile.init_date = parseInt(
          this.egress_profile.init_date.substr(0, 4)
        );
    this.fetchFacultyArea();
  },
};
</script>

<style scoped>
.textarea {
  border: 1px solid rgb(160, 160, 160);
}
.btn-add {
  border: none;
  background: transparent;
  font-size: 13pt;
  padding: 0;
  margin-left: 0.7rem;
}
.v-select >>> .vs__search,
.v-select >>> .vs__search:focus {
  font-size: 0.875rem !important;
  color: #495057 !important;
}

.v-select-class >>> .vs__selected {
  background-color: #99c9d8 !important;
  color: #fff !important;
}
.v-select >>> .vs__clear {
  margin-bottom: 0.2rem !important;
}
.icon-btn-ai {
  width: 18px;
  height: 18px;
}
::v-deep .btn-ai-quick {
  background-color: var(--kl-fourth-hover-color) !important;
  border-color: var(--kl-fourth-hover-color) !important;
  color: white !important;
}
::v-deep .btn-ai-quick:hover {
  opacity: 0.9;
}
</style>